import type {
    EditTermDTO,
    OPCTermDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';
import AdjustDeductible from './AdjustDeductible';
import { useRecoilValue } from 'recoil';
import { opcInfoAtom } from '../../../../recoil/atoms/opcInfoAtom';
import { getTermOPCInfoSelector } from '../../../../recoil/selectors/getTermOPCInfo';

const AdjustAudioTelco = ({
    termInfo,
    updateTermValue,
    isAdjustableDataValid
}: {
    termInfo: OPCTermDTO;
    updateTermValue: (termValue: number, publicId?: string) => void;
    isAdjustableDataValid: boolean;
}): JSX.Element => {
    const { coverableId, productName, coverageId } = useRecoilValue(opcInfoAtom);
    const carContentEditTermDTO: EditTermDTO = {
        coverableId,
        productName,
        coverageId: coverageId ?? '',
        termId: 'MVPComprehensiveContentValue'
    };
    const carContentTermOPCInfo = useRecoilValue(
        getTermOPCInfoSelector(JSON.stringify(carContentEditTermDTO))
    );

    return (
        <>
            <AdjustDeductible
                termInfo={termInfo}
                updateTermValue={updateTermValue}
                isAdjustableDataValid={isAdjustableDataValid}
                overrideSubHeader="DSS-ADJUST-MVP-AUDIO-TEXT"
                overrideErrorMsg={'ADJUST-MVP-AUDIO-ERROR-TEXT'}
            />
            {carContentTermOPCInfo?.isEditableSum === true &&
                termInfo?.name !== 'MVPComprehensiveContentValue' && (
                    <AdjustDeductible
                        termInfo={carContentTermOPCInfo}
                        updateTermValue={updateTermValue}
                        isAdjustableDataValid={isAdjustableDataValid}
                        overrideSubHeader="DSS-ADJUST-MVP-MOBILHOME-SUM-TEXT"
                    />
                )}
        </>
    );
};

export default AdjustAudioTelco;
